import { render } from "./PolicyDetailsPage.vue?vue&type=template&id=b65fcd1e"
import script from "./PolicyDetailsPage.vue?vue&type=script&lang=js"
export * from "./PolicyDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__